module.exports = __webpack_public_path__ + "static/media/status.f3224e45.png";